import { Cohort } from 'root-constants'
import { TValueOf } from 'root-types'

export const HEADER_VARIANTS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
} as const

export const COHORTS_WITH_BURGER_MENU = [Cohort.BP_BIBLE_2284]

export type THeaderVariant = TValueOf<typeof HEADER_VARIANTS>

export const HEADER_BORDER_COLOR = 'rgba(0, 0, 0, 0.18)'
